import { Injectable, Inject } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CustomerList, JobsiteList, ChangeImplementJobsiteData } from './change-implement-jobsite-modal';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
@Injectable()
export class ChangeImplementJobsiteModalService {
    constructor(private _http: Http) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
    public returnCustomersByUserId(): Observable<CustomerList[]> {
        return this._http.get("Api/Customer/customerListForLoggedInUser", {}).share().map(
            (response: Response) => <CustomerList[]>response.json()).catch(this.handleError);
    }
    public returnJobsitesByCustomerId(id: number = 0): Observable<JobsiteList[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('customerId', id.toString());
        return this._http.get("Api/GETJobsite/jobsiteListForCustomer", { search: params }).share().map(
            (response: Response) => <JobsiteList[]>response.json()).catch(this.handleError);
    }
    public saveImplementJobsiteChange(data: ChangeImplementJobsiteData): Observable<string> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('implementId', data.implementId.toString());
        params.set('customerId', data.customerId.toString());
        params.set('jobsiteId', data.jobsiteId.toString());
        params.set('cost', data.cost.toString());
        params.set('date', data.date.toDateString());
        params.set('comment', data.comment.toString());
        return this._http.get("Api/Implement/changeImplementJobsite", { search: params }).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
    }
}